export enum ActionsMenuType {
  RESCHEDULE = 'reschedule',
  CANCEL = 'cancel',
  BOOK_AGAIN = 'book_again',
  DIVIDER = 'divider',
}

export interface ActionMenuConfiguration {
  type: ActionsMenuType;
  Component: React.ReactNode;
}

export enum ActionButtonUiTypes {
  MENU = 'menu',
  BUTTON = 'button',
  LINK = 'link',
}
